// Create TransactionContext.tsx
import React, { createContext, useState, useContext, useEffect } from 'react';

interface TransactionContextType {
    encodedFunctionData: string;
    setEncodedFunctionData: (data: string) => void;
}

const TransactionContext = createContext<TransactionContextType | undefined>(undefined);

export const TransactionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [encodedFunctionData, setEncodedFunctionData] = useState('');
    const [selectedFunction, setSelectedFunction] = useState('');
    const [selectedContract, setSelectedContract] = useState(null);
    const [functionInputs, setFunctionInputs] = useState({});

    // Add localStorage persistence
    useEffect(() => {
        const savedFunction = localStorage.getItem('selected_function');
        const savedContract = localStorage.getItem('selected_contract');
        const savedInputs = localStorage.getItem('function_inputs');

        if (savedFunction) setSelectedFunction(savedFunction);
        if (savedContract) setSelectedContract(JSON.parse(savedContract));
        if (savedInputs) setFunctionInputs(JSON.parse(savedInputs));
    }, []);

    // Save to localStorage when values change
    useEffect(() => {
        if (selectedFunction)
            localStorage.setItem('selected_function', selectedFunction);

        if (selectedContract)
            localStorage.setItem('selected_contract', JSON.stringify(selectedContract));

        if (Object.keys(functionInputs).length > 0)
            localStorage.setItem('function_inputs', JSON.stringify(functionInputs));
    }, [selectedFunction, selectedContract, functionInputs]);

    return (
        <TransactionContext.Provider value={{ encodedFunctionData, setEncodedFunctionData }}>
            {children}
        </TransactionContext.Provider>
    );
};

export const useTransaction = () => {
    const context = useContext(TransactionContext);
    if (!context) {
        throw new Error('useTransaction must be used within a TransactionProvider');
    }
    return context;
};